<template>
  <div class="px-6">
    <!-- LOADING DATA -->
    <LoadingPage v-if="loading"></LoadingPage>
    <!-- COMPLETE VIEW -->
    <div v-else>
      <ParkingForm :parking="parkingById" class="mb-6"></ParkingForm>
      <SpotList :attributes="getAttributes"></SpotList>
    </div>
  </div>
</template>

<script>
import LoadingPage from "../components/common/LoadingPage.vue";
import ParkingForm from "../components/Parkings/ParkingForm.vue";
import SpotList from "../components/Parkings/SpotList.vue";

export default {
  name: "ParkingDetails",

  components: {
    LoadingPage,
    ParkingForm,
    SpotList,
  },

  created() {
    this.parkingId = this.$route.params.id;
    this.fetchSpots();
  },

  data() {
    return {
      loading: false,
      parkingId: null,
    };
  },

  computed: {
    parkingList() {
      return this.$store.getters.parkings;
    },

    parkingById() {
      return this.$store.getters.parkingById(this.parkingId);
    },

    getAttributes() {
      return this.$store.getters.attributes;
    },

    selectedClient() {
      return this.$store.getters.selectedClient;
    },
  },

  watch: {
    selectedClient(nVal, oVal) {
      if (nVal.id !== oVal.id) {
        this.$router.push("/parkings");
      }
    },
  },

  methods: {
    async fetchSpots() {
      this.loading = true;
      await this.$store.dispatch("fetch_spots", this.parkingId);
      await this.$store.dispatch("fetch_attributes");
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
